module.exports = "/virtual-football/img/video/clubs/england/m-united.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/england/m-united.png
// module id = 288
// module chunks = 6